import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Query, View, ViewUpdate } from '@wdx/clmi/clmi-swagger-gen';
import { BaseApiService } from '../base-api.service';
import { ViewUrlSegment } from './view-url-segment';
import { ApiConfigService } from '../api-config.service';

@Injectable({ providedIn: 'root' })
export class ViewApiService extends BaseApiService {
    constructor(http: HttpClient, apiConfig: ApiConfigService) {
        super(http, apiConfig);
    }

    getAll(): Observable<View[]> {
        return this.get<View[]>(`${ViewUrlSegment.View}`);
    }

    getForEntity(
        entityType: string,
        typeCode?: string,
        options?: { isContextual?: boolean; isLookup?: boolean },
    ): Observable<View[]> {
        const queryParams: string[] = [];

        if (typeCode) {
            queryParams.push(`typeCode=${typeCode}`);
        }
        if (options?.isContextual) {
            queryParams.push(`contextual=${options.isContextual}`);
        }
        if (options?.isLookup) {
            queryParams.push(`lookup=${options.isLookup}`);
        }

        const queryString = queryParams.length
            ? `?${queryParams.join('&')}`
            : '';

        return this.get<View[]>(
            `${ViewUrlSegment.View}/${entityType}${queryString}`,
        );
    }

    getSingleForEntityType(
        viewId: string,
        entityType: string,
    ): Observable<View> {
        return this.get<View>(`${ViewUrlSegment.View}/${entityType}/${viewId}`);
    }

    create(entityType: string, view: View): Observable<View> {
        return this.post<View, any>(
            `${ViewUrlSegment.View}/${entityType}`,
            view,
        );
    }

    update(viewId: string, entityType: string, view: View): Observable<View> {
        const payload: ViewUpdate = {
            filter: view.filter as Query,
            name: view.name as string,
        };
        return this.put<View>(
            `${ViewUrlSegment.View}/${entityType}/${viewId}`,
            payload,
        );
    }

    deleteView(viewId: string, entityType: string): Observable<any> {
        return this.delete(`${ViewUrlSegment.View}/${entityType}/${viewId}`);
    }

    share(
        viewId: string,
        entityType: string,
        partyId: string,
    ): Observable<object> {
        return this.patch(
            `${ViewUrlSegment.View}/${entityType}/${viewId}/${ViewUrlSegment.Share}/${partyId}`,
            {},
        );
    }
}
